import React from 'react';
import ReactDOM from 'react-dom/client';
import axios, { AxiosHeaders } from 'axios';
import './index.css';
import App from './App';
import { applyAuthErrorHandlers } from './shared/utils/apiErrors';
import { getApiAuthHeaders, onBeforeApiRequest } from './shared/utils/api';
import { getAccessToken } from './shared/auth/okta';

axios.interceptors.request.use(async (config) => {
  await onBeforeApiRequest();
  const headers = AxiosHeaders.from(config.headers ?? {});
  const auth = getApiAuthHeaders(getAccessToken());
  Object.entries(auth).forEach(([key, value]) => {
    headers.set(key, value);
  });
  config.headers = headers;
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    if (status !== undefined) applyAuthErrorHandlers(status);
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
